import type { MatrixCell, ReportBundle } from '../../../shared/types.js';
import { LEVELS } from '../../../shared/levels.js';

// Colour bucket from height above the assigned band. <=0 is at/below band;
// +1..+2 → plum; +3 or more → accent. (No stretch dot — distance is the signal.)
function heatClass(cell: MatrixCell): string {
  if (cell.count === 0) return 'mx-empty';
  if (cell.steps_above_assigned <= 0) return 'mx-at';
  if (cell.steps_above_assigned >= 3) return 'mx-hot';
  return 'mx-warm';
}

export function MatrixView({ report }: { report: ReportBundle }) {
  const assigned = report.config.assigned_level;
  const target = report.config.target_level;
  return (
    <div className="matrix">
      <table className="mx">
        <thead>
          <tr>
            <th className="mx-dim">Dimension</th>
            {LEVELS.map((l) => (
              <th key={l} className={l === assigned ? 'mx-col-assigned' : l === target ? 'mx-col-target' : ''}>
                {l}
                {l === assigned && <span className="mx-marker">assigned</span>}
                {l === target && <span className="mx-marker">target</span>}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {report.dimensions.map((d) => (
            <tr key={d.id}>
              <td className="mx-dimname">{d.name}</td>
              {d.matrix.map((cell) => (
                <td
                  key={cell.level}
                  className={heatClass(cell)}
                  title={`${d.name} · ${cell.level}: ${cell.count} ${cell.count === 1 ? 'entry' : 'entries'}`}
                >
                  {cell.count > 0 ? cell.count : ''}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      <div className="mx-legend">
        <span className="mx-key">
          <span className="mx-sw mx-sw-at" /> at/below band
        </span>
        <span className="mx-key">
          <span className="mx-sw mx-sw-warm" /> +1–2 above
        </span>
        <span className="mx-key">
          <span className="mx-sw mx-sw-hot" /> +3 or more
        </span>
        <span className="mx-key">number = entries logged</span>
      </div>
    </div>
  );
}
